import React from 'react';
import styles from './index.module.scss'
import ira from "../../../../media/iconos/cupra/ira.svg";

class LinkButton extends React.Component {

  render() {

    return (
      <div className={styles.cupra}>
        <a className={styles.link} href={this.props.ruta} target="_blank" rel="noopener noreferrer">
          {this.props.title}
          <img src={ira} className={styles.icon} alt='goto' />
        </a>
      </div>
    )
  }
}

export default LinkButton
